export const Licenses = {
    PatientsSearch: 'patients-search',
    OrderCreation: 'order-creation',
    Orders: 'orders',
    Reports: 'reports',
    Shop: 'shop',
    Documents: 'documents',
    StructMibi: 'struct-mibi',
    Mibi: 'create-mibi',
} as const;
